export const SMSOptType = {
    Unknown: 1,
    OptInUnsent: 10,
    OptIn: 20,
    OptOut: 30
};
